import React, { useContext, useEffect } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import ThemeContext from "../utils/Contexts/ThemeContext";

const NavigationAlertModal = ({ open, onCancel, onConfirm }) => {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);

  useEffect(() => {
    const modalElement = document.getElementById("navigationModal");
    if (modalElement) {
      if (open) {
        modalElement.classList.add("show");
        modalElement.style.display = "block";
        modalElement.setAttribute("aria-hidden", "false");
      } else {
        modalElement.classList.remove("show");
        modalElement.style.display = "none";
        modalElement.setAttribute("aria-hidden", "true");
      }
    }
  }, [open]);

  if (!open) return null; // Don't render if the modal is not visible

  return (
    <div
      className="modal fade"
      id="navigationModal"
      tabIndex="-1"
      aria-labelledby="navigationModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog navigation-modal" role="document">
        <div
          className="modal-content alert-modal-custom"
          style={{
            background:
              selectedTheme === "dark" ? "#292D30" : "#E8EAEC",
          }}
        >
          <div className="modal-header" style={{ marginTop: "-30px"}}>
            <h1 className="navigation-modal-title" id="navigationModalLabel" style={{ fontSize: "20px",
              fontWeight: "700",}}>
              {t("You have unsaved changes")}
            </h1>
          </div>

          <div
            className="modal-body"
            style={{
              marginTop: "-20px",
              color: "#919293",
              marginBottom: "-20px",
              fontSize: "16px",
              fontWeight: "400",

            }}
          >
            {t(
              "If you leave now, your changes will be lost. Are you sure to leave?"
            )}
          </div>

          <div className="modal-footer alert-modal-footer">
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={onConfirm}
            >
              {t("Leave")}
            </button>
            <button
              type="button"
              className="btn"
              style={{backgroundColor:"#387CFF", color:"white"}}
              data-bs-dismiss="modal"
              onClick={onCancel}
            >
              {t("Cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationAlertModal;
